module.exports = __webpack_public_path__ + "static/media/copy-grey.0f8c9588.svg";